import React from "react";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import SectionTitle from "../components/SectionTitle";
import ServiceCard from "../components/ServiceCard";
import { services, assets } from "../data/siteData";

export default function SolutionsPage() {
  return (
    <>
      <SEO
        title="Water Solutions in Kolkata, West Bengal | Treatment, Pumps, Chlorination, Monitoring"
        description="Hydrotec Solutions offers complete water solutions in Kolkata, Newtown, Rajarhat, and West Bengal — including water treatment plants, pump systems, bacteria removal, chlorination, water ATMs, and IoT monitoring."
        keywords="water solutions Kolkata, water treatment West Bengal, pump systems Newtown, water ATM Kolkata, chlorination Rajarhat, water monitoring West Bengal, water infrastructure Kolkata"
        canonical="https://hydroteclimited.com/solutions"
      />
      <PageHero
        title="Solutions designed for safe water access and system performance."
        text="Explore Hydrotec’s full range of water infrastructure offerings across dispensing, treatment, pumping, monitoring, and wastewater systems."
        image={assets.chlorinationPlant}
      />

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
        <SectionTitle
          eyebrow="Our Solutions"
          title="Complete offerings for the modern water ecosystem."
          text="Each solution can be customized for public infrastructure, institutions, campuses, buildings, industry, and remote deployments."
          center
        />

        <div className="mt-12 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {services.map((item) => (
            <ServiceCard key={item.title} {...item} />
          ))}
        </div>
      </section>
    </>
  );
}